import { graphql } from 'react-relay';
import { Environment, fetchQuery } from 'relay-runtime';

import { checkTritxRefundQuery$data } from '@/__generated__/checkTritxRefundQuery.graphql';

export async function checkTritxRefund(relayEnvironment: Environment, refundId: string) {
  let result: checkTritxRefundQuery$data['checkTritxRefund'] | null = null;

  try {
    const data = (await fetchQuery(
      relayEnvironment,
      graphql`
        query checkTritxRefundQuery($refundId: String!) {
          checkTritxRefund(refundId: $refundId) {
            result
            refundStage
            refundStatus
            cancelStage
            errors {
              code
              message
            }
          }
        }
      `,
      {
        refundId
      }
    ).toPromise()) as checkTritxRefundQuery$data;

    result = data?.checkTritxRefund;
  } catch {
    // nothing to do
  }

  return result;
}
